import careTeam from "./documents/careTeam";
import { educationSettingsType } from "./documents/educationSettingsType";
import { educationalContentType } from "./documents/educationalContentType";
import { journeyContentType } from "./documents/journeyContentType";
import { lessonContentType } from "./documents/lessonContentType";
import { classContentType } from "./documents/classContentType";
import { programContentType } from "./documents/programContentType";
import { categoryContentType } from "./documents/categoryContentType";
import { sanctuaryHealthVideoType } from "./documents/sanctuaryHealthVideoType";
import { programFileAttachmentType } from "./objects/programFileAttachmentType";
import { programModuleItemType } from "./objects/programModuleItemType";
import { programRelatedDataType } from "./objects/programRelatedDataType";
import { sanctuaryPost } from "./objects/sanctuaryPost";
import { sanctuaryVideo } from "./objects/sanctuaryVideo";
import simpleBlocContent from "./objects/simpleBlocContent";
import simpleBlocContentWrap from "./objects/simpleBlocContentWrap";
import { syncVideosSanctuaryHealthType } from "./objects/syncVideosSanctuaryHealthType";
import { featureFlagType } from "./documents/featureFlagType";
import { featureFlagItemType } from "./objects/featureFlagItemType";
import { establishCareStepSettingsType } from "./documents/establishCareStepSettingsType";
import {
  availabilitySpecificDaysOfWeekObj,
  availabilityTimesObj,
  supportAvailabilityTypeDocument
} from "./documents/supportAvailabilityType";
import { sanctuaryCaptions } from "./objects/sanctuaryCaptions";
import { captionType } from "./objects/captionType";
import { appContentTypeDoc } from "./documents/appContentType";
import { appointmentType } from "./documents/appointmentType";

const schemaTypes = [
  simpleBlocContent,
  simpleBlocContentWrap,
  careTeam,
  programContentType,
  programFileAttachmentType,
  programModuleItemType,
  programRelatedDataType,
  educationalContentType,
  educationSettingsType,
  categoryContentType,
  appointmentType,
  journeyContentType,
  lessonContentType,
  classContentType,
  syncVideosSanctuaryHealthType,
  sanctuaryHealthVideoType,
  sanctuaryPost,
  sanctuaryVideo,
  sanctuaryCaptions,
  featureFlagType,
  featureFlagItemType,
  captionType,
  establishCareStepSettingsType,
  availabilityTimesObj,
  availabilitySpecificDaysOfWeekObj,
  supportAvailabilityTypeDocument,
  appContentTypeDoc
];

export default schemaTypes;
